import { Skeleton } from '../ui/skeleton';
import { cn } from '@/client/utils';
import { isDirectAssetUrl } from '@/client/utils/asset-url';
import { api } from '@/client/utils/api';
import { usePreloadImage } from '@/libs/react-sdk/api/use-preload-Image';
import { ImgHTMLAttributes } from 'react';

type UploadedImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  fileKey: string;
  min?: boolean;
};
export const UploadedImage = ({ fileKey, min = true, className, ...props }: UploadedImageProps) => {
  const isUrl = isDirectAssetUrl(fileKey);
  const finalFileKey = isUrl ? undefined : min && fileKey ? fileKey + '_icon' : fileKey;
  const { data, isLoading } = usePreloadImage(api, finalFileKey);
  const src = isUrl ? fileKey : data;
  if (isLoading) return <Skeleton className={cn('flex-shrink-0 size-full', className)} />;
  if (!fileKey || !src) return null;
  return (
    <img
      loading="lazy"
      alt=""
      {...props}
      src={src}
      className={cn('object-contain flex-shrink-0 size-full', className)}
    />
  );
};
